import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

const Profile = () => {
  const [userProfile, setUserProfile] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (!auth.currentUser) {
        navigate('/login');
        return;
      }

      try {
        const userRef = doc(db, 'users', auth.currentUser.uid);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
          setUserProfile(userSnap.data());
        } else {
          setUserProfile({ xp: 0, grade: '1' });
        }
      } catch (error) {
        console.error('Error fetching user profile:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-xl">Loading profile...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="max-w-md w-full p-6 bg-white rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold text-center text-gray-800 mb-6">
          Your Profile
        </h1>

        <div className="mb-8">
          <div className="flex items-center justify-center mb-4">
            <div className="w-20 h-20 bg-blue-500 rounded-full flex items-center justify-center text-white text-2xl font-bold">
              {auth.currentUser?.email?.charAt(0).toUpperCase() || 'U'}
            </div>
          </div>
          
          <p className="text-center text-gray-600 mb-2">
            {auth.currentUser?.email}
          </p>
        </div>

        <div className="mb-6 bg-gray-100 p-4 rounded-lg">
          <div className="flex justify-between mb-2">
            <span className="font-medium">Current Grade:</span>
            <span>{userProfile.grade}</span>
          </div>
          
          <div className="flex justify-between mb-2">
            <span className="font-medium">XP Earned:</span>
            <span>{userProfile.xp || 0}</span>
          </div>
          
          <div className="flex justify-between">
            <span className="font-medium">Quizzes Completed:</span>
            <span>{userProfile.quizzesCompleted || 0}</span>
          </div>
        </div>

        <div className="space-y-4">
          <button
            onClick={() => navigate('/select-grade')}
            className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600"
          >
            Change Grade
          </button>
          
          <button
            onClick={handleLogout}
            className="w-full bg-red-500 text-white py-2 rounded hover:bg-red-600"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile; 